import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import { useFavoriteCarsStore } from '@/stores/favorite-cars'

export const useCarsStore = defineStore('cars', () => {

    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()
    const favoriteCarsStore = useFavoriteCarsStore()

    const cars              = ref({})
    const carsProcess       = ref(false)
    const carsMsg           = ref({})

    const carsCreateProcess = ref(false)
    const carsCreateMsg     = ref({})

    const carsActivateProcess   = ref(false)
    const carsActivateMsg   = ref({})

    const carsDeleteProcess = ref(false)
    const carsDeleteMsg     = ref({})

    async function createCar(data) {

        carsCreateProcess.value = true
        const token = tokenStore.access
        let result = {}

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars`, 
                method: 'POST', 
                token,
                data
            })

            if(!request.error) {
                result = request
                carsCreateMsg.value = { success: true }
            } else {
                carsCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            carsCreateMsg.value = { success: false, text: 'EToken' }
        }

        carsCreateProcess.value = false
        return result
    }

    async function activateCar(data) {

        carsActivateProcess.value = true
        const token = tokenStore.access
        let result = {}

        if(token) { 

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/client/request_ownership`, 
                method: 'POST', 
                token,
                data
            })

            if(!request.error) {
                result = request
                carsActivateMsg.value = { success: true }
            } else {
                carsActivateMsg.value = { success: false, text: request.error }
            }

        } else {
            carsActivateMsg.value = { success: false, text: 'EToken' }
        }

        carsActivateProcess.value = false
        return result
    }

    async function readCars(payload) {

        carsProcess.value = true
        const token = tokenStore.access

        if(token) { 

            let params = ''

            if(payload) {
                for( let param in payload) {
                    if(Array.isArray(payload[param])) {
                        payload[param].map( el => {
                            params.length ?
                                params += '&' + param + '=' + el :
                                params = '?' + param + '=' + el
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                cars.value = request
                const favorites = await favoriteCarsStore.readFavoriteCars()
                if(favorites.uuidCarArray) {

                    cars.value.array.map( car => {

                        if(favorites.uuidCarArray.includes(car.uuid)) {

                            car.favorite = true
                        }
                    })
                }
                carsMsg.value = { success: true }
            } else {
                cars.value = {}
                carsMsg.value = { success: false, text: request.error }
            }

        } else {
            carsMsg.value = { success: false, text: 'EToken' }
        }

        carsProcess.value = false
        return cars.value
    }

    /**
     * Удаляет автомобили
     * 
     * @param {String} payload - UUID автомобиля
     */
    async function deleteCar(payload) {

        carsDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/${payload}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                carsDeleteMsg.value = { success: true, text: 'CAR_DELETE_SUCCESS' }
            } else {
                carsDeleteMsg.value = { success: false }
                carsDeleteMsg.value.text = request.error
            }

        } else {
            carsDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carsDeleteProcess.value = false
    }

    const setCars = data => cars.value = data
    const setCarsCreateMsg = data => carsCreateMsg.value = data
    const setCarsActivateMsg = data => carsActivateMsg.value = data

    return {
        cars,
        carsProcess,
        carsMsg,
        carsCreateProcess, 
        carsCreateMsg,
        carsActivateProcess,
        carsActivateMsg,
        carsDeleteProcess, 
        carsDeleteMsg, 
        createCar, 
        activateCar, 
        deleteCar, 
        readCars, 
        setCars, 
        setCarsCreateMsg, 
        setCarsActivateMsg
    }
})
